import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useEffect } from "react";

const VideoCarousel = () => {
//  console.log("VideoCarousel rendered");

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (current, next) => {
      // stop all videos
      const iframes = document.querySelectorAll(".carousel-video");

  
      iframes.forEach((iframe) => {
        const src = iframe.dataset.src; // original clean src
        if (src) iframe.setAttribute("src", src); // reset without autoplay
      });
    },
    afterChange: (current) => {
      // autoplay only the current slide
      const currentIframe = document.querySelectorAll(
        `.slick-slide[data-index="${current}"] .carousel-video`
      )[0];
      if (currentIframe) {
        const src = currentIframe.dataset.src;
        if (src) currentIframe.setAttribute("src", `${src}?autoplay=1`);
      }
    },
  };

  useEffect(() => {
     const currentIframe = document.querySelectorAll(
        `.slick-slide[data-index="0"] .carousel-video`
      )[0];
      if (currentIframe) {
        const src = currentIframe.dataset.src;
        if (src) currentIframe.setAttribute("src", `${src}?autoplay=1`);
      }
  }, []);

  return (
    <div id="video-carousel-container">
    <Slider {...settings}>
      <div>
        <iframe
          className="carousel-video aspect-[16/9] object-cover w-full h-full"
          data-src="https://www.youtube.com/embed/SYidqWRQenw"
          src="https://www.youtube.com/embed/SYidqWRQenw"
          title="Pasaporte hacia el empleo Usuarios"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
      <div>
        <iframe
          className="carousel-video aspect-[16/9] object-cover w-full h-full"
          data-src="https://www.youtube.com/embed/58IJfHlJDic"
          src="https://www.youtube.com/embed/58IJfHlJDic"
          title="Pasaporte hacia el empleo Tecnicos"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </Slider>
    </div>
  );
};

export default VideoCarousel;
